import React, { Component } from "react";
import { Row, Col, Card, Button, Container, Form, Modal } from "react-bootstrap";
import MultiSelect from "react-multi-select-component";
import './_admissionForm.scss';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { components } from 'react-select'
import { withApollo } from "react-apollo";
import moment from "moment";


const ADD_FORM_FIELD_DETAILS = gql`
mutation($params:AddFormFields){
    addFormFields(params:$params)
}
`;



const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
};

const getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: 'none',
    padding: '8px',
    margin: `0 0 8px 0`,
    background: isDragging ? 'lightgreen' : '#fff',
    border: '1px dashed #3C78EE',
    fontSize: '13px',
    ...draggableStyle,
});


class EnquiryLinksCreationModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            branch_id: "",
            branchError: "",
            form_name: "",
            form_name_error: "",
            dataClear: 0,
            formSearch: "",
            admissionFormError: "",
            formSelectedvalue: [],
            defaultSelectedValue: [],
            getAdmissionFields: [],
            loadingSpinner: 0,
            currentStep: 1,
            submitError: "",
            existing_form_field_id: 0,
            isDisabled: false,
        }
    }

    componentDidUpdate() {
        if (this.props.show === true && this.state.dataClear === 0) {
            let getAdmissionFields = [];
            let defaultSelectedValue = [];

            this.props.getFormFields.map((item) => {
                if (item.id == 1 || item.id == 2) {
                    const newObj = {
                        value: item.id,
                        label: item.form_field_name,
                        id: item.id.toString(),
                    }
                    defaultSelectedValue.push(newObj);
                } else {
                    const newObj1 = {
                        value: item.id,
                        label: item.form_field_name,
                        id: item.id.toString(),
                    }
                    getAdmissionFields.push(newObj1)
                }
            })

            this.setState({
                branch_id: "",
                branchError: "",
                form_name: "",
                form_name_error: "",
                dataClear: 1,
                getAdmissionFields: getAdmissionFields,
                formSelectedvalue: [],
                defaultSelectedValue: defaultSelectedValue,
                loadingSpinner: 0,
                currentStep: 1,
                submitError: "",
            });

            if (this.props.stateData.existingAdmissionFormFields.length > 0) {
                let existingData = this.props.stateData.existingAdmissionFormFields;
                console.log("existingData", existingData);

                let existing_form_fields = [];


                if (existingData && existingData.length > 0) {

                    const existingFieldData = existingData[0].form_field_ids.split(',');
                    existingFieldData.filter((item1) => item1 != 1 && item1 != 2).map((item) => {
                        const formField = this.props.getFormFields.find(item1 => item1.id == parseInt(item));
                        existing_form_fields.push({ label: formField.form_field_name, value: formField.id, id: formField.id.toString() });
                    })

                    this.setState({
                        branch_id: this.props.stateData.branch_id,
                        form_name: existingData[0].form_name,
                        formSelectedvalue: existing_form_fields,
                        existing_form_field_id: existingData[0].existing_form_field_id,
                        isDisabled: true,
                    });

                }

            } else {
                this.setState({
                    isDisabled: false
                })
            }
        }
        if (this.props.show === false && this.state.dataClear === 1) {
            this.setState({ dataClear: 0 });
        }
    };

    selecthandleInputChange = (e) => {
        console.log("111111", e.target.value, e.target.name);
        let name = e.target.name;
        let value = e.target.value;

        if (name == "branch") {
            this.setState({
                branch_id: value,
                branchError: "",
                form_name: "",
                form_name_error: "",
                formSearch: "",
                form_name_error: "",
                admissionFormError: "",
                formSelectedvalue: [],
            })
        } else {
            this.setState({
                form_name: "",
                form_name_error: "",
                formSearch: "",
                form_name_error: "",
                admissionFormError: "",
                formSelectedvalue: [],
            })
        }

        if (name == "form_name") {
            this.setState({
                formSearch: "",
                form_name_error: "",
                admissionFormError: "",
                formSelectedvalue: [],
            });
        } else {
            this.setState({
                formSearch: "",
                form_name_error: "",
                admissionFormError: "",
                formSelectedvalue: [],
            })
        }
        this.setState({ [name]: value });
    };

    handleMultipleSelectInputChange = (e, name) => {
        if (name == "formSearch") {
            let formSelectedvalue = [];

            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const formfields = e[i];
                    const newObj = {
                        label: formfields.label,
                        value: formfields.value,
                        id: formfields.id.toString(),
                    }
                    console.log("newObj", formfields);
                    formSelectedvalue.push(newObj);
                }
            }
            this.setState({
                formSelectedvalue: formSelectedvalue,
                formSearch: "",
                form_name_error: "",
                admissionFormError: "",
            });
        }
    };

    onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }

        const reorderedData = reorder(
            this.state.formSelectedvalue,
            result.source.index,
            result.destination.index
        );

        this.setState({ formSelectedvalue: reorderedData })
    };

    handleFormSubmit = (e) => {

        if (this.state.branch_id == "") {
            this.setState({ branchError: " Please Select Branch" })
            return ""
        }

        if (this.state.form_name == "") {
            this.setState({ form_name_error: " Please Enter Form Name " })
            return ""
        }


        let form_field_ids = [];

        this.state.defaultSelectedValue.map((item) => {
            form_field_ids.push(item.id)
        })

        this.state.formSelectedvalue.map((item) => {
            form_field_ids.push(item.id)
        })


        let params = {}
        if (this.state.existing_form_field_id > 0) {
            params = {
                form_name: this.state.form_name,
                form_field_ids: form_field_ids.toString(),
                updated_by: parseInt(Cookies.get("id")),
                existing_form_field_id: parseInt(this.state.existing_form_field_id),
            }
        } else {
            params = {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(this.state.branch_id),
                form_name: this.state.form_name,
                form_field_ids: form_field_ids.toString(),
                inserted_by: parseInt(Cookies.get("id")),
                existing_form_field_id: parseInt(this.state.existing_form_field_id),
            }
        }


        console.log("daaaaa", params);

        this.setState({ loadingSpinner: 1 })
        this.addFormFields(params).catch(error => {
            this.setState({ submitError: error.graphQLErrors.map(x => x.message), loadingSpinner: 0 });
            setTimeout(() => {
                this.props.onHide();
                window.location.reload(false);
            }, 1500);
        })
    };

    addFormFields = async params => {
        await this.props.addFormFields({
            variables: {
                params
            },
            update: (store, { data }) => {
                console.log("dataaaaaaaaaaaaaa", data);
                if (data.addFormFields) {
                    this.setState({
                        loadingSpinner: 0,
                        currentStep: 5,
                    });
                    setTimeout(() => {
                        this.props.onHide();
                        window.location.reload(false);
                    }, 1500);
                }

            }
        })
    }

    SetpageLoad = () => {
        this.setState({ currentStep: 1, submitError: "" });
        this.props.onHide();
    };

    render() {

        console.log("state1232", this.state.branch_id, this.state);
        console.log("stateData123", this.props.stateData.branch_id);

        let admissionFieldsSelectAll = true;
        let admissionFieldslabelledby = "Select";
        let formFieldsdisablesearch = false;

        if (this.props.getFormFields.length > 0) {
            admissionFieldsSelectAll = true;
            formFieldsdisablesearch = false;
        } else {
            formFieldsdisablesearch = true;
            admissionFieldsSelectAll = false;
            admissionFieldslabelledby = "admissionForm";
        }
        return (
            <Modal {...this.props} size="md" aria-labelledby="example-modal-sizes-title-lg">
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-lg">Enquiry Link Creation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col xl={12} lg={12} md={12} sm={12} className="mt-3">
                            <Form>
                                <Form.Row>
                                    <Form.Group as={Col} lg={4} md={12} sm={12} controlId="SelectBranchName">
                                        <Form.Label className="text-uppercase font-weight-bold">Select Branch</Form.Label>
                                        <Form.Control as="select" name="branch" onChange={this.selecthandleInputChange} value={this.state.branch_id} disabled={this.state.isDisabled}>
                                            <option value={this.state.defaultvalue}>--Select Branch--</option>
                                            {this.props.globals.globalBranches.map(branchData => (
                                                <option value={branchData.id}>{branchData.branch_name}</option>
                                            ))}
                                        </Form.Control>
                                        <Form.Text className="form-text text-danger">
                                            {this.state.branchError}
                                        </Form.Text>
                                    </Form.Group>

                                    <Form.Group as={Col} lg={4} md={12} sm={12} controlId="SelectMaterial">
                                        <Form.Label className="text-uppercase font-weight-bold">Form Name</Form.Label>
                                        <input type="text" name="form_name" className="form-control" onChange={this.selecthandleInputChange} value={this.state.form_name} disabled={this.state.isDisabled} placeholder="Enter Form Name" />
                                        <Form.Text className="form-text text-danger">
                                            {this.state.form_name_error}
                                        </Form.Text>
                                    </Form.Group>

                                    <Form.Group as={Col} lg={4} md={12} sm={12} controlId="SelectMaterial">
                                        <Form.Label className="text-uppercase font-weight-bold">Form Fields</Form.Label>
                                        <MultiSelect
                                            overrideStrings={{
                                                allItemsAreSelected: "All Fields are selected.",
                                                selectSomeItems: admissionFieldslabelledby,
                                            }}
                                            disableSearch={formFieldsdisablesearch}
                                            hasSelectAll={admissionFieldsSelectAll}
                                            options={this.state.getAdmissionFields}
                                            value={this.state.formSelectedvalue}
                                            onChange={(e) => this.handleMultipleSelectInputChange(e, "formSearch")}
                                            labelledBy={"formSearch"}
                                        />
                                        <Form.Text className="form-text text-danger">
                                            {this.state.admissionFormError}
                                        </Form.Text>
                                    </Form.Group>
                                </Form.Row>
                            </Form>
                        </Col>
                    </Row>

                    <div>
                        <Row>
                            <Col>
                                <DragDropContext onDragEnd={this.onDragEnd}>
                                    <Droppable droppableId="droppable">
                                        {(provided) => (
                                            <div ref={provided.innerRef} {...provided.droppableProps} style={{ margin: '20px' }}>
                                                <ul style={{ listStyleType: 'none', padding: 0 }}>
                                                    <Row>
                                                        <Col lg={12} md={12} sm={12}>
                                                            <Card className="card-mainsData">
                                                                <Card.Body>
                                                                    <Row>
                                                                        {
                                                                            this.state.defaultSelectedValue.map((item, index) => {
                                                                                return (
                                                                                    <Col lg={12} md={12} sm={12} >
                                                                                        <Card className="defaultValues">
                                                                                            <Card.Body>
                                                                                                <Row>
                                                                                                    {/* <Col sm={2} className="text-center defaultSelectedValues"><i class="fas fa-star text-danger"></i></Col> */}
                                                                                                    <Col sm={10}><p className="fw-bold h6 text-center defaultSelectednames"><span className="text-danger">*</span>{index + 1}     .{item.label}</p> </Col>
                                                                                                </Row>
                                                                                            </Card.Body>
                                                                                        </Card>
                                                                                    </Col>
                                                                                )
                                                                            })

                                                                        }
                                                                    </Row>
                                                                    <Droppable droppableId="droppable">
                                                                        {(provided) => (
                                                                            <div
                                                                                ref={provided.innerRef}
                                                                                {...provided.droppableProps}
                                                                                style={{ margin: '20px' }}
                                                                            >
                                                                                <Row>
                                                                                    {this.state.formSelectedvalue.map((field, index) => (
                                                                                        <Col key={field.id} lg={12} md={12} sm={12}>
                                                                                            <Draggable draggableId={field.id} index={index}>
                                                                                                {(provided, snapshot) => (
                                                                                                    <p>
                                                                                                        <li
                                                                                                            ref={provided.innerRef}
                                                                                                            {...provided.draggableProps}
                                                                                                            {...provided.dragHandleProps}
                                                                                                            style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                                                                                                        >
                                                                                                            <p className="h6 formSelectedValues" style={{ marginLeft: "103px" }} >{index + 3}.       <span>{field.label}</span></p>
                                                                                                        </li>
                                                                                                    </p>
                                                                                                )}
                                                                                            </Draggable>
                                                                                        </Col>
                                                                                    ))}
                                                                                </Row>

                                                                            </div>
                                                                        )}
                                                                    </Droppable>
                                                                </Card.Body>
                                                            </Card>
                                                        </Col>
                                                    </Row>
                                                </ul>
                                            </div>
                                        )}
                                    </Droppable>
                                </DragDropContext>
                            </Col>
                        </Row>
                    </div>

                    <Row>
                        <Col sm={12} className="d-flex justify-content-end">
                            <div className='d-block'>
                                {this.state.currentStep == 5 ? (
                                    <Form.Text className="form-text text-Success mb-2 " style={{ textAlign: "center" }}>
                                        <p style={{ color: "green" }}>Link Created successfully</p>
                                    </Form.Text>
                                ) : (
                                    <Form.Text className="form-text text-danger mb-2" style={{ textAlign: "center", display: "none" }}>
                                        {this.state.submitError}
                                    </Form.Text>
                                )}
                            </div>

                            <button className='form_submitButton mr-4 w-25 text-uppercase' onClick={this.handleFormSubmit}>
                                {
                                    this.state.loadingSpinner == 1 ? (
                                        <span className="spinner-border spinner-border-sm text-white mr-4"></span>
                                    ) : ""
                                }Submit</button>

                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        )
    }
}

export default withRouter(compose(
    graphql(ADD_FORM_FIELD_DETAILS, {
        name: "addFormFields"
    })
)(EnquiryLinksCreationModal));






